import Vue from 'vue';
import VueI18n from 'vue-i18n';
import apiInst from './api/api.js';

import _ from 'lodash';

Vue.use(VueI18n);

const loadedLanguages = [];

export const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'nl',
  fallbackLocale: localStorage.getItem('language') || 'nl'
});

export function setI18nLanguage(lang) {
  i18n.locale = lang;
  apiInst.defaults.headers.common['Accept-Language'] = lang;
  document.querySelector('html').setAttribute('lang', lang);
  return lang;
}

export function loadLanguagesListAsync() {
  return apiInst.get('/localization/list/languages');
}

export function getTranslationsForLanguage(lang) {
  return apiInst.get(`/localization/${lang}`)
}

export function updateTranslationText(payload) {
  return apiInst.post(`/localization/update`, payload)
}


export function loadLanguageAsync(lang = i18n.locale) {
  if (loadedLanguages.includes(lang)) {
    if (i18n.locale !== lang) setI18nLanguage(lang);
    return Promise.resolve();
  }
  return getTranslationsForLanguage(lang).then((response) => {
    const jsonObject = {};
    Object.keys(response.data).forEach((key) => {
      
      const keys = key.split('.');
      let currentObj = jsonObject;
      
      keys.forEach((k, index) => {
        if (!currentObj[k]) {
          currentObj[k] = {};
        }
        
        if (index === keys.length - 1) {
          currentObj[k] = response.data[key].trim();
        } else {
          currentObj = currentObj[k];
        }
      });
    });
    let msgs = _.merge(jsonObject);
    loadedLanguages.push(lang);
    i18n.setLocaleMessage(lang, msgs);
    setI18nLanguage(lang);
  });
}
